import {
  CREATE_PAGE_REQUEST, CREATING_PAGE_SUCCEEDED, CREATING_PAGE_FAILED,
  UPDATE_PAGE_REQUEST, UPDATING_PAGE_SUCCEEDED, UPDATING_PAGE_FAILED,
  PUBLISH_PAGE_REQUEST, PUBLISHING_PAGE_SUCCEEDED, PUBLISHING_PAGE_FAILED,
  CREATE_PAGE_PUBLISH_REQUEST, UPDATE_PAGE_PUBLISH_REQUEST, INVALIDATE_PAGE_PUBLISH_REQUEST,
  RESTORE_PAGE_REQUEST, RESTORING_PAGE_SUCCEEDED, RESTORING_PAGE_FAILED,
  INVALIDATE_PAGE_STATE, INVALIDATE_PAGE_NAVIGATION,

  CLONE_LANDING_PAGE_REQUEST, CLONE_LANDING_PAGE_SUCCEEDED, CLONE_LANDING_PAGE_FAILED,

  SEARCH_PAGES_FOR_STORYBOARD_REQUEST, SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED, SEARCHING_PAGES_FOR_STORYBOARD_FAILED,
  QUERY_PAGES_FOR_STORYBOARD_REQUEST, QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED, QUERY_PAGES_FOR_STORYBOARD_FAILED, INVALIDATE_PAGE_QUERY,
  FETCH_PAGE_REQUEST, FETCHING_PAGE_SUCCEEDED, FETCHING_PAGE_FAILED,
  FETCH_PAGES_FOR_SELECTION_REQUEST, FETCHING_PAGES_FOR_SELECTION_SUCCEEDED, FETCHING_PAGES_FOR_SELECTION_FAILED, INVALIDATE_PAGES_FOR_SELECTION, 
  DELETE_PAGE_REQUEST, DELETING_PAGE_SUCCEEDED, DELETING_PAGE_FAILED, INVALIDATE_PAGE_DELETE,

  UPDATE_PAGE_SETTINGS,
  UPDATE_LANDING_PAGE_SETTINGS_REQUEST, UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED, UPDATE_LANDING_PAGE_SETTINGS_FAILED,
  UPDATE_PAGE_VISIBILITY_REQUEST, UPDATE_PAGE_VISIBILITY_SUCCEEDED, UPDATE_PAGE_VISIBILITY_FAILED, 
  START_AUTO_SAVE_PAGE_TASK, STOP_AUTO_SAVE_PAGE_TASK, AUTO_SAVE_PAGE_REQUEST, AUTO_SAVING_PAGE_SUCCEEDED, AUTO_SAVING_PAGE_FAILED,
  UPDATE_PAGES_TO_RENDER, FETCH_SLIDES_FOR_PAGE_REQUEST, FETCH_SLIDES_FOR_PAGE_SUCCEEDED, FETCH_SLIDES_FOR_PAGE_FAILED, REARRANGE_PAGE_WIDGETS, REARRANGE_PAGE_WIDGETS_SUCCEEDED, REARRANGE_PAGE_WIDGETS_FAILED,
  UPDATE_VARIABLE_MAPPINGS, REMOVE_VARIABLE_MAPPINGS
} from 'constants/actionTypes';

import { LIVE_ELEMENT, PAGE, TEXT } from 'constants/widgetTypes';

import { FETCH_PAGE, SAVE_PAGE, PUBLISH_PAGE } from 'constants/transactionalMetricTypes'

import { put, call, takeEvery, select, take, race, fork, delay } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import moment from 'moment';
import axios from 'axios';
import buildUrl from 'build-url';
import _ from 'lodash';
import { calculateOrderForWidgets } from 'components/Editor/helper/widget';
import { WidgetRegistry } from 'components/Editor/widgets/registry';

import { updatePageSettings } from 'actions/editor';
import { invalidateStoryboardPages, triggerPageProcessingForStoryboard, updateHomePageForStoryboard } from './storyboard';
import { createTransactionalMetrics } from './transactionalMetrics';
import LockService from 'services/lock.service';

import { broadcastMessage } from "components/Broadcaster";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const PAGE_URL = `${apiUrl}/api/2.0/pages`;

/**
 * Create page
*/
export const createPage = createAction(CREATE_PAGE_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

export const createPageSucceeded = createAction(CREATING_PAGE_SUCCEEDED, (response) => {
  return response;
})

export const createPageFailed = createAction(CREATING_PAGE_FAILED, (error) => {
  return error;
})

function* createPageSage(action) {
  const { request, callback } = action.payload;

  const createPageAPI = () => {
    return axios.post(PAGE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createPageAPI);
    if (response) {
      if (callback) {
        callback(response);
      }

      yield put(createPageSucceeded(response));
    }
  } catch (error) {
    yield put(createPageFailed(error));
  }
}

/**
 * Clone landing page
*/
export const cloneLandingPage = createAction(CLONE_LANDING_PAGE_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
})

export const cloneLandingPageSucceeded = createAction(CLONE_LANDING_PAGE_SUCCEEDED, (response) => {
  return response;
})

export const cloneLandingPageFailed = createAction(CLONE_LANDING_PAGE_FAILED, (error) => {
  return error;
})

function* cloneLandingPageSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/clone`
  });

  const cloneLandingPageAPI = () => {
    return axios.put(url).then(response => response.data);
  }

  try {
    const response = yield call(cloneLandingPageAPI);
    if (response) {
      if (callback) {
        callback(response);
      }
      yield put(cloneLandingPageSucceeded(response));
    }
  } catch (error) {
    yield put(cloneLandingPageFailed(error));
  }
}

/**
 * Update page
*/
export const updatePage = createAction(UPDATE_PAGE_REQUEST, (id, editorSession, callback) => {
  return {
    id: id,
    editorSession: editorSession,
    callback: callback
  }
});

const updatingPageSucceeded = createAction(UPDATING_PAGE_SUCCEEDED, (id, response, editorSession) => {
  return { id, response, editorSession };
});

const updatingPageFailed = createAction(UPDATING_PAGE_FAILED, (id, error) => {
  return { id, error };
});

function* updatePageSaga(action) {
  const { id, editorSession } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}`
  });


  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock({
      type: 'page',
      id: id,
    }),
  }

  const updatePageAPI = (request) => {
    return axios.put(url, request, {
      headers: headers,
    }).then(response => response.data);
  }

  try {
    // const revision = `rev_${shortid.generate()}`;
    const snapshot = yield select(state => {
      var widgets = _.get(state, `${editorSession}.present.widgets`);
      widgets = widgets.filter(
        widget =>
          !(widget.uid?.includes("widget_loading") ||
          widget.uid?.toLowerCase().startsWith("widget_loading"))
      );
      widgets = calculateOrderForWidgets(widgets, null);
      widgets = widgets.map((widget) => {
        let allFonts = [];
        if (widget.type === LIVE_ELEMENT && widget.children !== null) {
          let childrenWidgets = widget.children;
    
          childrenWidgets.forEach((childWidget) => {
            if (childWidget.fonts !== null && childWidget.fonts !== undefined) {
              childWidget.fonts.map((font) => allFonts.push(font));
            }
          });
          if (allFonts.length > 0) {
            widget.fonts = allFonts;
          }
        }
        return widget;
      });
      widgets = WidgetRegistry.processRequest(widgets);

      const desktopGuides = _.get(state, `${editorSession}.present.desktop.guides`);
      const mobileGuides = _.get(state, `${editorSession}.present.mobile.guides`);

      var page = _.get(state, `pages.page[${id}].item`);
      var name = _.get(page, 'name', '');
      var alias = _.get(page, 'canonical', '');
      var autoCreateAlias = _.get(page, 'autoCreateAlias', false);
      var seo = _.get(page, 'draft.seo', {});
      var appearance = _.get(state, `${editorSession}.present.appearance`);
      var themes = _.get(state, `${editorSession}.present.themes`);
      var brandTheme = _.get(state, `${editorSession}.present.brandTheme`) || {"colors": null};
      var social = _.get(page, 'draft.social', {});
      var socialIcon = _.get(social, 'icon', null);
      var variableMappings = _.get(page, 'variableMappings', null);

      if (socialIcon) {
        social = {
          ...social,
          icon: socialIcon.id
        }
      }
      if (appearance) {
        var appearanceBackground = _.get(appearance, 'background');
        var slideBackground = _.get(appearance, 'slideBackground');

        appearance = {
          ...appearance,
          background: {
            ...appearance.background,
            media: _.get(appearanceBackground, 'media') ? _.get(appearanceBackground, 'media.id') : null
          },
          slideBackground: {
            ...slideBackground,
            media: _.get(slideBackground, 'media') ? _.get(slideBackground, 'media.id') : null
          }
        }
      }
      var twitter = _.get(page, 'draft.twitter', {});
      var twitterIcon = _.get(twitter, 'icon', null);
      if (twitterIcon) {
        twitter = {
          ...twitter,
          icon: twitterIcon.id
        }
      }

      var pageRequest = { widgets, desktopGuides, mobileGuides, name, alias, appearance, themes, brandTheme, autoCreateAlias, seo, social, twitter, variableMappings }

      if (page.storyboard.type === "INTERACTIVE_CONTENT") {
        pageRequest = _.omit(pageRequest, ['alias']);
      }

      return pageRequest;
    });

    var startDate = moment().format("DD-MM-YYYY hh:mm:ss A");
    var appearance =  yield select(state => _.get(state, `pages.page[${id}].item.storyboard.appearance`));
    var prevSlideBackground = _.get(appearance, 'slideBackground');
    const response = yield call(updatePageAPI, snapshot);
    if (response) {
      var endDate = moment().format("DD-MM-YYYY hh:mm:ss A");
      var secondsDiff = moment(endDate, 'DD-MM-YYYY hh:mm:ss').diff(moment(startDate, 'DD-MM-YYYY hh:mm:ss'), 'seconds');
      var storyboard = _.get(response, 'storyboard.id');
      var storyboardType = _.get(response, 'storyboard.type');
      var nextSlideBackground = _.get(response, 'storyboard.appearance.slideBackground');
      
      if (storyboardType == 'SPATIAL' && !_.isEqual(prevSlideBackground, nextSlideBackground)){
        yield put(triggerPageProcessingForStoryboard(storyboard));
        yield put(invalidateStoryboardPages(storyboard));
      }

      var payload = {
        startDate: startDate,
        endDate: endDate,
        duration: secondsDiff,
        page: id,
        type: SAVE_PAGE
      }

      const request = {
        payload: JSON.stringify(payload),
        storyboard: storyboard,
        duration: secondsDiff
      }

      yield put(createTransactionalMetrics(request))

      yield put(updatingPageSucceeded(id, response, editorSession));
    }

    var widgets = _.get(response, 'draft.widgets', []);

    for (let i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      if (widget.type === PAGE) {
        var alias = _.get(widget, 'properties.desktop.alias');

        yield put(updatePageSettings(editorSession, widget, widget.uid, 'desktop', {
          alias: alias
        }))
      }
    }

    broadcastMessage(updatingPageSucceeded(id, response, editorSession));

  } catch (error) {
    console.log(error);
    yield put(updatingPageFailed(id, error));
  }
}

/**
 * Publish page
*/
export const publishPage = createAction(PUBLISH_PAGE_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  }
})

const publishPageSucceeded = createAction(PUBLISHING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const publishPageFailed = createAction(PUBLISHING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* publishPageSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/publish`
  });

  const publishPageAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    var startDate = moment().format("DD-MM-YYYY hh:mm:ss A");
    const response = yield call(publishPageAPI);
    if (response) {
      var endDate = moment().format("DD-MM-YYYY hh:mm:ss A");
      var secondsDiff = moment(endDate, 'DD-MM-YYYY hh:mm:ss').diff(moment(startDate, 'DD-MM-YYYY hh:mm:ss'), 'seconds');
      var storyboard = _.get(response, 'storyboard.id');
      let storyboardType = _.get(response, 'storyboard.type');

      var payload = {
        startDate: startDate,
        endDate: endDate,
        duration: secondsDiff,
        page: id,
        type: PUBLISH_PAGE
      }

      const request = {
        payload: JSON.stringify(payload),
        storyboard: storyboard,
        duration: secondsDiff
      }

      if (storyboardType === 'SPATIAL'){
        yield put(invalidateStoryboardPages(storyboard));
      }

      yield put(createTransactionalMetrics(request))

      yield put(publishPageSucceeded(id, response));
    }
    if (callback) yield call(callback, response);
  } catch (error) {
    yield put(publishPageFailed(id, error));
  }
}

export const invalidatePageState = createAction(INVALIDATE_PAGE_STATE, (id) => {
  return id;
});

export const invalidatePageChange = createAction(INVALIDATE_PAGE_NAVIGATION, (id) => {
  return id;
});

/**
 * Publish page request
*/
export const createPublishRequest = createAction(CREATE_PAGE_PUBLISH_REQUEST, (items) => {
  return {
    items: items
  };
});

export const updatePublishRequest = createAction(UPDATE_PAGE_PUBLISH_REQUEST, (request) => {
  return request;
})

export const invalidatePublishRequset = createAction(INVALIDATE_PAGE_PUBLISH_REQUEST);

/**
 * Restore page
*/
export const restorePage = createAction(RESTORE_PAGE_REQUEST, (id, editorSession, callback) => {
  return {
    id: id,
    editorSession: editorSession,
    callback: callback
  }
})

const restorePageSucceeded = createAction(RESTORING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const restorePageFailed = createAction(RESTORING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* restorePageSaga(action) {
  const { id, editorSession, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/restore`
  });

  const restorePageAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(restorePageAPI);
    yield put(restorePageSucceeded(id, response));
    if (callback) yield call(callback, response);
  } catch (error) {
    yield put(restorePageFailed(id, error));
  }
}

/**
 * Selection pages for landing and resource center storyboard
*/
export const fetchPagesForSelection = createAction(FETCH_PAGES_FOR_SELECTION_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const fetchPagesForSelectionSucceeded = createAction(FETCHING_PAGES_FOR_SELECTION_SUCCEEDED, (response) => {
  return response;
})

const fetchPagesForSelectionFailed = createAction(FETCHING_PAGES_FOR_SELECTION_FAILED, (error) => {
  return error;
})

function* fetchPagesForSelectionSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `search?page=${page}&limit=${limit}`
  });

  const fetchPagesForSelectionAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPagesForSelectionAPI);
    if (response) {
      yield put(fetchPagesForSelectionSucceeded(response));
    }
  } catch (error) {
    yield put(fetchPagesForSelectionFailed(error));
  }
}

/**
 * Emptying Search pages for storyboard
*/
export const InvalidatePagesForSelection = createAction(INVALIDATE_PAGES_FOR_SELECTION);

/**
 * Search pages for storyboard
*/
export const searchPages = createAction(SEARCH_PAGES_FOR_STORYBOARD_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const searchPagesSucceeded = createAction(SEARCHING_PAGES_FOR_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

const searchPagesFailed = createAction(SEARCHING_PAGES_FOR_STORYBOARD_FAILED, (error) => {
  return error;
})

function* searchPagesSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `search?page=${page}&limit=${limit}`
  });

  const searchPagesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(searchPagesAPI);
    if (response) {
      yield put(searchPagesSucceeded(response));
    }
  } catch (error) {
    yield put(searchPagesFailed(error));
  }
}

/**
 * Search pages for storyboard
*/
export const queryPages = createAction(QUERY_PAGES_FOR_STORYBOARD_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const queryPagesSucceeded = createAction(QUERY_PAGES_FOR_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

const queryPagesFailed = createAction(QUERY_PAGES_FOR_STORYBOARD_FAILED, (error) => {
  return error;
})

export const invalidatePageQuery = createAction(INVALIDATE_PAGE_QUERY)

function* queryPagesSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `search?page=${page}&limit=${limit}`
  });

  const queryPagesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(queryPagesAPI);
    if (response) {
      yield put(queryPagesSucceeded(response));
    }
  } catch (error) {
    yield put(queryPagesFailed(error));
  }
}

/**
 * Fetch page for {id}
*/
export const fetchPage = createAction(FETCH_PAGE_REQUEST, (id, lazy, personalizationId, segmentId) => {
  return {
    id: id,
    lazy: lazy,
    personalizationId: personalizationId,
    segmentId: segmentId
  }
})

const fetchingPageSucceeded = createAction(FETCHING_PAGE_SUCCEEDED, (response) => {
  return response;
})

const fetchPageFailed = createAction(FETCHING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchPageSaga(action) {
  const { id, lazy = false, personalizationId = null, segmentId = null } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: id
  });
  

  let headers = {
    'SPATIAL-LAZY-LOAD': lazy
  }

  if (personalizationId || segmentId) {
    headers = {
      ...headers,
      ...(personalizationId && { 'CS-PERSONALIZATION-ID': personalizationId }),
      ...(segmentId && { 'CS-AUDIENCESEGMENT-ID': segmentId }),
    };
  }

  const fetchPageAPI = () => {
    return axios({
      method: 'get',
      url: url,
      headers: headers
    }).then(response => response.data);
  }

  try {
    var startDate = moment().format("DD-MM-YYYY hh:mm:ss A");
    const response = yield call(fetchPageAPI);
    if (response) {
      var endDate = moment().format("DD-MM-YYYY hh:mm:ss A");
      var secondsDiff = moment(endDate, 'DD-MM-YYYY hh:mm:ss').diff(moment(startDate, 'DD-MM-YYYY hh:mm:ss'), 'seconds');
      var storyboard = _.get(response, 'storyboard.id');

      var payload = {
        startDate: startDate,
        endDate: endDate,
        duration: secondsDiff,
        page: id,
        type: FETCH_PAGE
      }

      const request = {
        payload: JSON.stringify(payload),
        storyboard: storyboard,
        duration: secondsDiff
      }
      yield put(createTransactionalMetrics(request))

      yield put(fetchingPageSucceeded(response));
    }
  } catch (error) {
    yield put(fetchPageFailed(id, error));
  }
}

/**
 * Delete page for {id}
*/
export const deletePage = createAction(DELETE_PAGE_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
});

const deletePageSucceeded = createAction(DELETING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const deletePageFailed = createAction(DELETING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

export const invalidatePageDelete = createAction(INVALIDATE_PAGE_DELETE);

function* deletePageSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: id
  });

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock({
      type: 'page',
      id: id
    })
  }

  const deletePageAPI = () => {
    return axios.delete(url, {
      headers: headers
    }).then(response => response.data);
  }

  try {
    const response = yield call(deletePageAPI);
    yield put(deletePageSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(deletePageFailed(id, error));
  }
}

export const updatePageVisibility = createAction(UPDATE_PAGE_VISIBILITY_REQUEST, (id, hidden) => {
  return {
    id: id,
    hidden: hidden
  };
});

const updatePageVisibilitySucceeded = createAction(UPDATE_PAGE_VISIBILITY_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const updatePageVisibilityFailed = createAction(UPDATE_PAGE_VISIBILITY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* updatePageVisibilitySaga(action) {
  const { id, hidden } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `/${id}/visibility`
  });

  var params = {
    hidden: hidden
  }

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock({
      type: 'page',
      id: id,
    }),
  }

  const updatePageVisibilityAPI = () => {
    return axios({
      method: 'post',
      url: url,
      params: params,
      headers: headers
    }).then(response => response.data)
  }

  try {
    const response = yield call(updatePageVisibilityAPI);
    yield put(updatePageVisibilitySucceeded(id, response));

  } catch (error) {
    console.log("page error", error);
    yield put(updatePageVisibilityFailed(id, error));
  }
}

/**
 * LandingPage Settings
*/
export const updateLandingPageSettings = createAction(UPDATE_LANDING_PAGE_SETTINGS_REQUEST, (id) => {
  return {
    id: id
  }
});

const updateLandingPageSettingsSucceeded = createAction(UPDATE_LANDING_PAGE_SETTINGS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const updateLandingPageSettingsFailed = createAction(UPDATE_LANDING_PAGE_SETTINGS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
});

function* updateLandingPageSettingsSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}`
  });

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock({
      type: 'page',
      id: id
    }),
  }

  const updateLandingPageSettingsAPI = (request) => {
    return axios({
      method: 'PUT',
      url: url,
      data: request,
      headers: headers
    }).then(response => response.data);
  }

  try {
    const snapshot = yield select(state => {
      var page = _.get(state, `pages.page[${id}].item`);
      var name = _.get(page, 'name', '');
      var alias = _.get(page, 'canonical', '');
      var autoCreateAlias = _.get(page, 'autoCreateAlias', false);
      var seo = _.get(page, 'draft.seo', {});
      var social = _.get(page, 'draft.social', {});
      var socialIcon = _.get(social, 'icon', null);
      if (socialIcon) {
        social = {
          ...social,
          icon: socialIcon.id
        }
      }

      var twitter = _.get(page, 'draft.twitter', {});
      var twitterIcon = _.get(twitter, 'icon', null);
      if (twitterIcon) {
        twitter = {
          ...twitter,
          icon: twitterIcon.id
        }
      }

      return { name, alias, autoCreateAlias, seo, social, twitter };
    });

    const response = yield call(updateLandingPageSettingsAPI, snapshot);
    if (response) {
      yield put(updateLandingPageSettingsSucceeded(id, response));
    }

  } catch (error) {
    yield put(updateLandingPageSettingsFailed(id, error));
  }
}

/**
 * update page settings
*/
export const updatePageMetadata = createAction(UPDATE_PAGE_SETTINGS, (id, request) => {
  return {
    id: id,
    request: request
  }
})

/**
 * rearrange page widgets
*/
export const rearrangePageWidgets = createAction(REARRANGE_PAGE_WIDGETS, (id, request, items) => {
  return {
    id: id,
    request: request,
    items: items
  }
})

const rearrangePageWidgetsSucceeded = createAction(REARRANGE_PAGE_WIDGETS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const rearrangePageWidgetsFailed = createAction(REARRANGE_PAGE_WIDGETS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
});

function* rearrangePageWidgetsSaga(action) {
  const { id, request, items } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `/${id}/order`
  });

  const rearrangePageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(rearrangePageAPI);
    if (response) {
      yield put(rearrangePageWidgetsSucceeded(response, items));
      yield put(updateHomePageForStoryboard(response));
    }
  } catch (error) {
    yield put(rearrangePageWidgetsFailed(error));
  }

}

/**
 * Auto save pages
 * 
*/

export const startAutoSavePageTask = createAction(START_AUTO_SAVE_PAGE_TASK, (id, editorSession) => {
  return {
    id: id,
    editorSession: editorSession,
  }
});

export const stopAutoSavePageTask = createAction(STOP_AUTO_SAVE_PAGE_TASK, (id) => {
  return {
    id: id,
  }
});

function* autoSaveBackgroundTask(id, editorSession) {
  while (true) { 
    yield delay(120000);

    const updating = yield select(state => _.get(state, `pages.page.${id}.update`));
    if (updating) {
      console.log("Ignoring auto save as the page is being saved");
      return;
    }

    const changedWidgets = yield select(state => {
      var currentWidgets = _.get(state, `${editorSession}.present.widgets`);
      var previousWidgets = _.get(state, `pages.page.${id}.item.draft.widgets`) || [];
      const variableMappings = _.get(state, `pages.page.${id}.item.variableMappings`) || [];
      const deletedVariableMappings = _.get(state, `pages.page.${id}.item.deletedVariableMappings`) || [];

      currentWidgets =[...currentWidgets];
      previousWidgets =[...previousWidgets];

      currentWidgets = calculateOrderForWidgets(currentWidgets, null);
      currentWidgets = WidgetRegistry.processRequest(currentWidgets);

      previousWidgets = calculateOrderForWidgets(previousWidgets, null);
      previousWidgets = WidgetRegistry.processRequest(previousWidgets);

      const widgets = currentWidgets.filter(widget => {
        const previous = previousWidgets.find(prevWidget => {
          return _.isEqual(prevWidget, widget);  
        });

        if(previous){
          previousWidgets = previousWidgets.filter(item => item !== previous);
        }

        return previous == null;
      });

      const deletedWidgets = previousWidgets.filter(prevWidget => {
        const deleted = currentWidgets.find(widget => {
          return _.isEqual(_.get(prevWidget, 'id'), _.get(widget, 'id'));
        });

        return deleted == null;
      });

      return {
        widgets: widgets,
        deletedWidgets: deletedWidgets,
        variableMappings: variableMappings,
        deletedVariableMappings: deletedVariableMappings
      };
    });

    const snapshot = yield select(state => {
      const desktopGuides = _.get(state, `${editorSession}.present.desktop.guides`);
      const mobileGuides = _.get(state, `${editorSession}.present.mobile.guides`);

      var themes = _.get(state, `${editorSession}.present.themes`);
      var brandTheme = _.get(state, `${editorSession}.present.brandTheme`) || {"colors": null};

      var pageRequest = { desktopGuides, mobileGuides, themes, brandTheme }

      return pageRequest;
    });

    const previousSnapshot = yield select(state => {
      const desktopGuides = _.get(state, `pages.page.${id}.item.draft.desktop.guides`);
      const mobileGuides = _.get(state, `pages.page.${id}.item.draft.mobile.guides`);

      var themes = _.get(state, `pages.page.${id}.item.storyboard.themes`);
      var brandTheme = _.get(state, `pages.page.${id}.item.storyboard.brandTheme`) || {"colors": null};

      var pageRequest = { desktopGuides, mobileGuides, themes, brandTheme }

      return pageRequest;
    });

    var request = {};
    if(_.size(changedWidgets.widgets) > 0 || _.size(changedWidgets.deletedWidgets) > 0 || _.size(changedWidgets.variableMappings) > 0){
      if(changedWidgets.deletedWidgets.some(widget => widget.type === PAGE)){
        return;
      }
      changedWidgets.deletedWidgets = changedWidgets.deletedWidgets.map(widget => _.get(widget, 'id'))
      request = changedWidgets;
    }

    if(!_.isEqual(snapshot, previousSnapshot)){
      request = {
        ...request,
        ...snapshot,
      }
    }

    if(_.size(_.keys(request)) > 0){
      yield put(autoSavePage(id, editorSession, request));
    }
  }
}

export const autoSavePage = createAction(AUTO_SAVE_PAGE_REQUEST, (id, editorSession, request) => {
  return {
    id: id,
    editorSession: editorSession,
    request: request
  }
});


const autoSavingPageSucceeded = createAction(AUTO_SAVING_PAGE_SUCCEEDED, (id, editorSession, response) => {
  return { id, editorSession, response };
});

const autoSavingPageFailed = createAction(AUTO_SAVING_PAGE_FAILED, (id, editorSession, error) => {
  return { id, editorSession, error };
});

function* autoSavePageSaga(action) {
  const { id, editorSession, request } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}`
  });

  const headers = {
    'CS-ENTITY-LOCK-TOKEN': LockService.getLock({
      type: 'page',
      id: id,
    }),
  }

  const autoSavePageAPI = (request) => {
    return axios.patch(url, request, {
      headers: headers,
    }).then(response => response.data);
  }

  try {
    var startDate = moment().format("DD-MM-YYYY hh:mm:ss A");
    const response = yield call(autoSavePageAPI, request);

    if (response) {
      var endDate = moment().format("DD-MM-YYYY hh:mm:ss A");
      var secondsDiff = moment(endDate, 'DD-MM-YYYY hh:mm:ss').diff(moment(startDate, 'DD-MM-YYYY hh:mm:ss'), 'seconds');
      var storyboard = _.get(response, 'storyboard.id');

      var payload = {
        startDate: startDate,
        endDate: endDate,
        duration: secondsDiff,
        page: id,
        type: SAVE_PAGE
      }

      const request = {
        payload: JSON.stringify(payload),
        storyboard: storyboard,
        duration: secondsDiff
      }

      yield put(createTransactionalMetrics(request))
      yield put(autoSavingPageSucceeded(id, editorSession, response));

      broadcastMessage(autoSavingPageSucceeded(id, editorSession, response));
    }
  } catch (error) {
    console.log(error);
    yield put(autoSavingPageFailed(id, editorSession, error));
  }
}

function* watchAutosaveBackgroundTask() {
  while (true) {
    const action = yield take(START_AUTO_SAVE_PAGE_TASK);
    const { id, editorSession } = action.payload;

    yield race({
      task: call(autoSaveBackgroundTask, id, editorSession),
      cancel: take(STOP_AUTO_SAVE_PAGE_TASK)
    })
  }
}


/**
 * Update Pages to render
*/
export const updatePagesToRender = createAction(UPDATE_PAGES_TO_RENDER, (pages, activePage) => {
  return {
    pages: pages,
    activePage: activePage
  };
})

/**
 * Fetch Slides on the Page
*/
export const fetchSlidesForPage = createAction(FETCH_SLIDES_FOR_PAGE_REQUEST, (id, page, limit = 10) => {
  return {
    id: id,
    page: page,
    limit: limit
  };
})

const fetchSlidesForPageSucceeded = createAction(FETCH_SLIDES_FOR_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const fetchSlidesForPageFailed = createAction(FETCH_SLIDES_FOR_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* fetchSlidesForPageSaga(action) {
  const { id, page, limit } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/slides/all?page=${page}&limit=${limit}`
  });

  const fetchSlidesForPageAPI = () => {
    return axios.post(url).then(response => response.data);
  };

  try {
    const response = yield call(fetchSlidesForPageAPI);
    if (response) {
      yield put(fetchSlidesForPageSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchSlidesForPageFailed(id, error));
  }
}

export const removeVariableMapping = createAction(REMOVE_VARIABLE_MAPPINGS, (id, mappingId) =>{
  return {
    id: id,
    mappingId:mappingId
  };
})

export const updateVariableMappings = createAction(UPDATE_VARIABLE_MAPPINGS, (id, request, deletable=[]) => {
  return {
    id: id,
    request: request,
    deletable: deletable
  };
})

export default function* storyboardSaga() {
  yield takeEvery(CREATE_PAGE_REQUEST, createPageSage);
  yield takeEvery(CLONE_LANDING_PAGE_REQUEST, cloneLandingPageSaga);
  yield takeEvery(UPDATE_PAGE_REQUEST, updatePageSaga);
  yield takeEvery(UPDATE_LANDING_PAGE_SETTINGS_REQUEST, updateLandingPageSettingsSaga)
  yield takeEvery(REARRANGE_PAGE_WIDGETS, rearrangePageWidgetsSaga);
  yield takeEvery(PUBLISH_PAGE_REQUEST, publishPageSaga);
  yield takeEvery(RESTORE_PAGE_REQUEST, restorePageSaga);
  yield takeEvery(SEARCH_PAGES_FOR_STORYBOARD_REQUEST, searchPagesSaga);
  yield takeEvery(QUERY_PAGES_FOR_STORYBOARD_REQUEST, queryPagesSaga);
  yield takeEvery(FETCH_PAGES_FOR_SELECTION_REQUEST, fetchPagesForSelectionSaga);
  yield takeEvery(FETCH_PAGE_REQUEST, fetchPageSaga);
  yield takeEvery(DELETE_PAGE_REQUEST, deletePageSaga);
  yield takeEvery(UPDATE_PAGE_VISIBILITY_REQUEST, updatePageVisibilitySaga);
  yield takeEvery(AUTO_SAVE_PAGE_REQUEST, autoSavePageSaga);
  yield takeEvery(FETCH_SLIDES_FOR_PAGE_REQUEST, fetchSlidesForPageSaga);
  yield fork(watchAutosaveBackgroundTask);
}
